module.exports = __webpack_public_path__ + "img/icon-building-old.c1d1bd75.svg";